require('./brokerRightsBuySidebar.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const moment = require('moment');

// @ helpers
const { getLanguage, formatText, FormattedText } = require('core/i18n').i18n;
const { formatCurrency, getFormattedString, formatAmount, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @ constants
const {
    FIRST_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    CHARGE_ACCOUNT_PREFIX,
    EURO_TEXT,
    BROKER_TYPE_RIGHT_NEW_DECIMALS
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @utilities
const DateHelper = require('utilities/dateHelper');

class BrokerRightsBuySidebar extends React.Component {
    buildFirstStepSidebar() {
        const { immBrokerRightsBuy, immCorporatesOperations } = this.props;
        const selectedCorporateOperationIndex = immBrokerRightsBuy.get('selectedCorporateOperationIndex');
        const selectedCorporateOperation = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex]);
        const closeDate = moment(selectedCorporateOperation.get('closeDate'));
        const fields = [];

        fields[fields.length] = (
            <div key={fields.length} className="broker-rights-buy-sidebar__item">
                <div className="broker-rights-buy-sidebar__item-label">
                    <FormattedText
                        value="broker-rightsBuySidebarDeadlineLabel"
                        format="uppercase"
                    />
                </div>
                <div className="broker-rights-buy-sidebar__item-name">
                    {DateHelper.buildFormattedDate(closeDate, formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))}
                </div>
            </div>
        );

        return fields;
    }

    buildQuotationSection () {
        const { quotation, quotationDate, quotationTime } = this.props;
        let section;

        if (quotationTime && quotationDate) {
            let formattedDate = DateHelper.getFormattedDate(quotationDate);
            const quotationAmount = formatAmount(quotation.get('amount'), getLanguage(), BROKER_TYPE_RIGHT_NEW_DECIMALS);
            const currency = formatCurrency(EURO_TEXT); // @hardcoded

            section = (
                <div className="broker-rights-buy-sidebar__item">
                    <div className="broker-rights-buy-sidebar__item-label">
                        <FormattedText value="broker-rightsQuotation" format="uppercase" />
                    </div>
                    <div className="broker-rights-buy-sidebar__item-name">
                        {quotationAmount} {currency}
                    </div>
                    <div className="broker-rights-buy-sidebar__item-additional-information">
                        {formattedDate}, {quotationTime}
                    </div>
                </div>
            );
        } else {
            section = (
                <div className="broker-rights-buy-sidebar__item">
                    <div className="broker-rights-buy-sidebar__item-label">
                        <FormattedText value="broker-rightsQuotation" format="uppercase" />
                    </div>
                    <div className="broker-rights-buy-sidebar__item-name">
                        -
                    </div>
                </div>
            );
        }

        return section;
    }

    buildSecondStepSidebar() {
        const {
            immBrokerRightsBuy,
            immCorporatesOperations,
            immFlagBasedFeatures,
        } = this.props;
        const orderTypeOption = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'orderTypeOption']);
        const validityDate = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'validityDate']);
        const limitedValue = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'orderTypeValue']);

        const selectedCorporateOperationIndex = immBrokerRightsBuy.get('selectedCorporateOperationIndex');
        const selectedCorporateOperation = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex]);
        const closeDate = moment(selectedCorporateOperation.get('closeDate'));

        const fields = [];
        const formattedLimitedValue = getFormattedString({
            amount: limitedValue,
            decimalsLength: BROKER_TYPE_RIGHT_NEW_DECIMALS,
            currency: EURO_TEXT // @hardcoded
        });

        const showExAntCostRightBuy = immFlagBasedFeatures.get('wealth_rights_buy_show_costs');
        const exAnteData = immBrokerRightsBuy.get('exAnteCostsList');
        const estimatedBaseAmount = !!exAnteData
            ? exAnteData.get("estimatedBaseAmount")
            : null;

        const rightsToBuy = parseInt(immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'rightsQuantity'])) || 0;
        let rightsToBuyValue, rightsToBuyTooltip;
        if(showExAntCostRightBuy && estimatedBaseAmount) {
            const estimatedBaseAmountValue = estimatedBaseAmount.get('amount');
            const estimatedBaseAmountCurrency = estimatedBaseAmount.get('currency');
            const arrayValues = [
                rightsToBuy,
                formatAmount(estimatedBaseAmountValue),
                formatCurrency(estimatedBaseAmountCurrency),
            ];
            rightsToBuyValue =
                !!estimatedBaseAmountValue && !!estimatedBaseAmountCurrency
                    ? formatText('broker-rightsBuyRightQuantityValue', arrayValues)
                    : rightsToBuy;
            rightsToBuyTooltip = (
                <OKTooltip
                    content="broker-rightsBuyRightQuantityTooltip"
                    offset={[0, -15]}
                />
            );
        } else {
            rightsToBuyValue = parseInt(immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'rightsQuantity'])) || 0;
            rightsToBuyTooltip = null;
        }

        let orderTypeText;

        switch (orderTypeOption) {
            case BROKER_ORDER_TYPE_TO_MARKET:
                orderTypeText = formatText('broker-rightsBuyToMarketOrderType');
                break;
            case BROKER_ORDER_TYPE_FOR_THE_BEST:
                orderTypeText = formatText('broker-rightsBuyForTheBestOrderType');
                break;
            case BROKER_ORDER_TYPE_LIMITED:
                orderTypeText = formatText('broker-rightsBuySuccessLimitedOrderType', [formattedLimitedValue]);
                break;
        }

        fields.push(
            <div className="broker-rights-buy-sidebar__item">
                <div className="broker-rights-buy-sidebar__item-label">
                    <FormattedText value="broker-broker_rightsBuyRightsQuantityLabel" format="uppercase" />
                    {rightsToBuyTooltip}
                </div>
                <div className="broker-rights-buy-sidebar__item-name">
                    {rightsToBuyValue}
                </div>
            </div>
        );

        fields.push(
            <div key={fields.length} className="broker-rights-buy-sidebar__item">
                <div className="broker-rights-buy-sidebar__item-label">
                    <FormattedText value="broker-rightsBuySidebarDeadlineLabel" format="uppercase" />
                </div>
                <div className="broker-rights-buy-sidebar__item-name">
                    {DateHelper.buildFormattedDate(closeDate, formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))}
                </div>
            </div>
        );

        fields.push(
            <div key={fields.length} className="broker-rights-buy-sidebar__item">
                <div className="broker-rights-buy-sidebar__item-label">
                    <FormattedText value="broker-rightsBuyTermOfValidityLabel" format="uppercase" />
                </div>
                <div className="broker-rights-buy-sidebar__item-name">
                    {DateHelper.buildFormattedDate(validityDate, formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))}
                </div>
            </div>
        );

        fields.push(
            <div key={fields.length} className="broker-rights-buy-sidebar__item">
                <div className="broker-rights-buy-sidebar__item-label">
                    <FormattedText value="broker-rightsBuyOrderTypeLabel" format="uppercase" />
                </div>
                <div className="broker-rights-buy-sidebar__item-name">
                    {orderTypeText}
                </div>
            </div>
        );

        return fields;
    }

    buildSidebar() {
        const {
            immBrokerRightsBuy,
            immCorporatesOperations,
            availableRights,
        } = this.props;
        const currentStep = immBrokerRightsBuy.get('visibleStep');
        const selectedCorporateOperationIndex = immBrokerRightsBuy.get(
            'selectedCorporateOperationIndex'
        );
        const selectedCorporateOperation = immCorporatesOperations.getIn([
            'selectedContract',
            'operations',
            selectedCorporateOperationIndex
        ]);
        const selectedContract = immCorporatesOperations.get('selectedContract');
        const proportion = selectedCorporateOperation.get('proportion');
        const fullAccountContract = CHARGE_ACCOUNT_PREFIX + selectedContract.getIn(['cuenta', 'digitodecontrol']) + selectedContract.getIn(['cuenta', 'fullNumber']);
        const quotationSection = this.buildQuotationSection ();
        const intervention = formatText(`interventionTypes-${selectedContract.get('intervention').trim()}`);
        const plainAmountObject = getPlainAmountObject(selectedContract.getIn(['associatedAccount','balance']));
        let dynamicContent;
        switch (currentStep) {
            case WIZARD_FIRST_STEP:
                dynamicContent = this.buildFirstStepSidebar();
                break;
            case WIZARD_SECOND_STEP:
                dynamicContent = this.buildSecondStepSidebar();
                break;
        }

        return (
            <OKSectionBox>
                <div className="broker-rights-buy-sidebar">
                    <div className="broker-rights-buy-sidebar__head-item">
                        <div className="broker-rights-buy-sidebar__head-item-label">
                            <FormattedText value="broker-rightsBuyValueLabel" />
                        </div>
                        <div className="broker-rights-buy-sidebar__head-item-name">
                            {selectedCorporateOperation.get('descriptionValue')}
                        </div>
                    </div>
                    {quotationSection}
                    <div className="broker-rights-buy-sidebar__item">
                        <div className="broker-rights-buy-sidebar__item-label">
                            <FormattedText
                                value="broker-rightsBuyContractLabel"
                                format="uppercase"
                            />
                        </div>
                        <div className="broker-rights-buy-sidebar__item-name">
                            {selectedContract.get('walletAccountType')}
                        </div>
                        <div className="broker-rights-buy-sidebar__item-additional-information">
                            <FormattedText
                                value="broker-rightsBuySidebarContractNumber"
                                injectedStrings={[fullAccountContract]}
                            />
                        </div>
                    </div>
                    <div className="broker-rights-buy-sidebar__item">
                        <div className="broker-rights-buy-sidebar__item-label">
                            <FormattedText
                                value="broker-rightsBuySidebarHolderLabel"
                                format="uppercase"
                            />
                        </div>
                        <div className="broker-rights-buy-sidebar__item-name">
                            {selectedContract.get('owner')}
                        </div>
                        <div className="broker-rights-buy-sidebar__item-additional-information">
                            <FormattedText
                                value="broker-rightsBuyInterventionLabel"
                                injectedStrings={[intervention]}
                            />
                        </div>
                    </div>
                    <div className="broker-rights-buy-sidebar__item">
                        <div className="broker-rights-buy-sidebar__item-label">
                            <FormattedText
                                value="broker-rightsBuySidebarAssociatedAccountLabel"
                                format="uppercase"
                            />
                        </div>
                        <div className="broker-rights-buy-sidebar__item-name">
                            {selectedContract.getIn(['associatedAccount', 'number'])}
                        </div>
                        <div className="broker-rights-buy-sidebar__item-additional-information">
                            <FormattedText value="broker-rightsBuyBalancePrefix" />
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                            <FormattedText value="broker-rightsBuyBalanceSuffix" />
                        </div>
                    </div>
                    <div className="broker-rights-buy-sidebar__item">
                        <div className="broker-rights-buy-sidebar__item-label">
                            <FormattedText value="broker-rightsProportion" format="uppercase" />
                            <OKTooltip
                                content="broker-rightsProportionTooltip"
                                offset={[0,-15]}
                            />
                        </div>
                        <div className="broker-rights-buy-sidebar__item-name">
                            {proportion}
                        </div>
                    </div>
                    <div className="broker-rights-buy-sidebar__item">
                        <div className="broker-rights-buy-sidebar__item-label">
                            <FormattedText value="broker-rightsBuyAvailables" format="uppercase" />
                        </div>
                        <div className="broker-rights-buy-sidebar__item-name">
                            {availableRights}
                        </div>
                    </div>
                    {dynamicContent}
                </div>
            </OKSectionBox>
        );
    }

    render() {
        const content = this.buildSidebar();

        return content;
    }
}

BrokerRightsBuySidebar.propTypes = {
    availableRights: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    immBrokerRightsBuy: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    quotation: PropTypes.object.isRequired,
    quotationTime: PropTypes.string.isRequired,
    quotationDate: PropTypes.string.isRequired
}

module.exports = BrokerRightsBuySidebar;
